import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Box from '@quintoandar/cozy-core/Box';

import Typography from '@quintoandar/cozy-core/Typography';
import { MessageDescriptorPropType } from '@quintoandar/cozy-core/proptypes/Intl';

export const IconDescription = ({ color, label, variant, icon: Icon }) => (
  <Box display="flex" pb={1}>
    <Box pr={1}>
      <Icon />
    </Box>
    <Typography level={variant} color={color}>
      <FormattedMessage {...label} />
    </Typography>
  </Box>
);

IconDescription.propTypes = {
  color: PropTypes.oneOf([
    'inherit',
    'primary',
    'textSecondary',
    'secondary',
    'error',
    'default',
  ]).isRequired,
  label: MessageDescriptorPropType.isRequired,
  icon: PropTypes.elementType.isRequired,
  variant: PropTypes.string,
};

export default IconDescription;
